/*
 * AboveContent
 */
import React from 'react';
import { useSelector } from 'react-redux';
import { Container } from 'semantic-ui-react';
import { getView } from '../../helpers';


const AboveContent = ({ pathname }) => {
    const content = useSelector((state) => state.content.data);
    const view = getView(pathname);

    const getShowAboveContent = () => {
        if (content && content['@type'] == 'Plone Site' && view == 'view')
            return false
        if (content && content['@type'] == 'Minisite' && view == 'view')
            return false
        if (view === 'controlpanel' || view === 'search' || view === 'add' || view === 'sitemap') {
            return false
        }
        if (content?.hide_above_content) {
            return false
        }
        return true
    }
    const showAboveContent = getShowAboveContent()

    return showAboveContent ? (
        <div className='firstHeadingWrapper'>
            {(content?.title) && (
                <h1 className="documentFirstHeading my-0">{content.title}</h1>
            )}
            {(content?.description) && (
                <p className="documentDescription mb-0 mt-2">{content.description}</p>
            )}
        </div>
    ) : (<></>);
};

export default AboveContent;
